import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
var AccordionContentMountOnExpand = function (_a) {
    var children = _a.children, expanded = _a.expanded;
    var isChildrenMountRef = useRef(expanded || false);
    var _b = __read(useState(expanded || false), 2), isChildrenMount = _b[0], setMountBool = _b[1];
    useEffect(function () {
        if (expanded) {
            isChildrenMountRef.current = true;
        }
    }, [expanded]);
    useEffect(function () {
        var timeoutId;
        if (expanded && isChildrenMountRef.current) {
            setMountBool(true);
        }
        else if (!expanded && isChildrenMountRef.current) {
            timeoutId = setTimeout(function () { return setMountBool(false); }, 500);
            isChildrenMountRef.current = false;
        }
        return function () { return (timeoutId ? clearTimeout(timeoutId) : undefined); };
    }, [expanded]);
    return isChildrenMount ? React.createElement(React.Fragment, null, children) : null;
};
export var AccordionContent = function (_a) {
    var children = _a.children, className = _a.className, expanded = _a.expanded, panel = _a.panel, _b = _a.mountOnlyOnExpand, mountOnlyOnExpand = _b === void 0 ? false : _b, restProps = __rest(_a, ["children", "className", "expanded", "panel", "mountOnlyOnExpand"]);
    return (React.createElement("div", __assign({}, restProps, panel, { className: twMerge(cx("h-auto overflow-hidden my-0 mx-6 \n            transition-all duration-500", 'text-body', { 'mt-0 mx-6 mb-6': expanded }, className)) }), mountOnlyOnExpand ? (React.createElement(AccordionContentMountOnExpand, { expanded: expanded || false }, children)) : (children)));
};
AccordionContent.displayName = 'AccordionContent';
